import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <CarouselSection />
        <MediaSection />
        <FeaturesSection />
        <AboutSection />
        <CommentsSection />
        <RankingSection />
        <IndexSection />
        <AppSection />
        <FaqSection />
        <UpdatesSection />
        <ContactSection />
        <TopicsSection />
      </main>
      <Footer />
    </div>
  );
}